import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Observer, of } from 'rxjs';
import { BatsConfirmComponent } from '../lib/bats-confirm/bats-confirm.component'

@Injectable({
  providedIn: 'root'
})
export class BATSCoreService {

  public appRoles: [];
  public CurrentUserUFID: string;
  public loadingCount = 0;

  constructor(
    private http: HttpClient,
    private modalService: NgbModal,
    @Inject('APP') private app: string,
    @Inject('API_BASE') private apiBase: string
  ) {
    this.GetData('/library/api/user/whoami', {"app": app}, '').subscribe((data: any) => {
      this.appRoles = data.ROLES ? data.ROLES : [];
      this.CurrentUserUFID = data.ufid;
    },
    (error: any) => {
      this.appRoles = [];
    });
  }

  public delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }

  public CheckRole(role) {
    // return true;
    return this.appRoles && this.appRoles.some((x: any) => x.APP = this.app && x.NAME == role);
  }

  public CheckRoleForUFID(role, ufid) {
    var observer: Observer<boolean>;

    var observable = new Observable(observer => {
      observer = observer;
    });

    this.GetData('/library/api/user/userCheck', {"app": this.app, "role": role, "ufid": ufid}).subscribe((data: any) => {
      observer.next(data.HAS_ROLE);
    });

    return observable;
  }

  public Confirm(text){
    const modalRef = this.modalService.open(BatsConfirmComponent)
    modalRef.componentInstance.text = text;
    return modalRef.result.then((result : any) => {
      return true;
    },
    (reason: any) => {
      return false;
    });
  }

  public GetData(endpoint, params = null, url = this.apiBase) {
    return this.http
      .get(url+endpoint, {params: params});
  }

  public PostData(endpoint, data, url = this.apiBase) {
    return this.http
      .post(url+endpoint, data);
  }

  public PutData(endpoint, data, url = this.apiBase) {
    return this.http
      .put(url+endpoint, data);
  }

  public DeleteData(endpoint, data, url = this.apiBase) {
    return this.http
      .request('delete', url+endpoint, {body: data});
  }

  public FacilityIDFromHex(hex) {
    return parseInt(this.hex2bin(hex).substring(2,14),2);
  }

  public IDFromHex(hex) {
    return parseInt(this.hex2bin(hex).substring(14,34),2);
  }

  public hex2bin(hex){
    return (parseInt(hex, 16).toString(2)).padStart(8, '0');
  }

  searchPerson(term: string) {
    if (term === '') {
      return of([]);
    }

    return this.GetData('/library/api/user/searchEveryone', { "srch": term }, '');
  }
}
